var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Seiten")]), _vm._v(" "), (_vm.selectedItem) ? _c('h2', [_vm._v("Bearbeiten: " + _vm._s(_vm.selectedItem.name))]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('LoadingSpinner') : [(!_vm.selectedItem) ? [(_vm.items && _vm.items.length > 0) ? _c('table', {
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Aktionen")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.selectedItem = item
        }
      }
    }, [_vm._v("Bearbeiten")])])])
  })], 2) : [_vm._v("\n        Keine Daten gefunden\n      ")]] : [_c('div', {
    staticClass: "edit-form"
  }, [_c('label', [_vm._v("\n          Text"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "https://de.wikipedia.org/wiki/Markdown",
      "target": "_blank"
    }
  }, [_vm._v("(Markdown-Syntax)")])])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.content),
      expression: "selectedItem.content"
    }],
    domProps: {
      "value": (_vm.selectedItem.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.content = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.selectedItem = null
      }
    }
  }, [_vm._v("Abbrechen")])]]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31fffbbc","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/admin/AdminPages.vue
// module id = 240
// module chunks = 1